<template>
  <Dialog v-model="dialog" icon="fas fa-trash-alt" title="確認">
    <template v-slot:content> 削除します。よろしいですか。 </template>
    <template v-slot:actions>
      <v-btn color @click="dialog = false" small>キャンセル</v-btn>
      <v-btn
        color="error"
        @click="handleDelete(item.Id)"
        small
        :loading="loading"
        >OK</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import { deletePratice } from "@/api/Pratice.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    async handleDelete() {
      this.loading = true;
      let params = {
        id: this.item.Id,
      };
      await deletePratice(params)
        .then(() => {
          this.$emit("resetList");
          this.loading = false;
          this.dialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>